import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordRequirementsDirective } from './password-requirements.directive';
import {
	PasswordRequirementsComponent
} from '@go-modules/directives/password-requirements/components/password-requirements.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		PasswordRequirementsDirective,
		PasswordRequirementsComponent
	],
	imports: [
		CommonModule,
		OverlayModule,
		TranslateModule
	],
	exports: [
		PasswordRequirementsDirective
	]
})
export class PasswordRequirementsModule {}
